class HoursOfServiceModel extends App.Models.BaseModel {
    modelUrl = 'HOS';
}

App.Models.HoursOfService = HoursOfServiceModel;
